export enum ChangeControlLabels {
  Collaborators = 'collaborators',
  ImplementationOwners = 'implementationOwners',
  Reviewers = 'reviewers',
  Approvers = 'approvers',
  Verifiers = 'verifiers',
  NotifiedUsers = 'notifiedUsers',
  InternalClientContact = 'internalClientContact',
  ClientNotificationOrApprovalRequired = 'clientNotificationOrApprovalRequired',
}
